module.exports = __webpack_public_path__ + "79c7a1b1e8a7d0eb458c6356fe2fa2ab.pdf";